/**
 * Converte uma data vinda do Rails para uma data compatível com os contadores
 * regressivos.
 * @param {string} date a data a ser convertida
 * @param {string} time indica a hora que a data deve ter
 * @return {Date}
 */
export default (date, time = '23:59:59') =>
  date && new Date(`${date.replace(/-/g, '/')} ${time}`);
